/* unplugin-vue-components disabled */import { render } from "./m_footer.vue?vue&type=template&id=467bff12"
const script = {}

import "./m_footer.vue?vue&type=style&index=0&id=467bff12&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__